import { render, staticRenderFns } from "./LoyaltyPrograms.vue?vue&type=template&id=5066dd37&scoped=true&lang=pug&"
import script from "./LoyaltyPrograms.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPrograms.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPrograms.vue?vue&type=style&index=0&id=5066dd37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066dd37",
  null
  
)

export default component.exports